import { Component, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PaginationMixin from '../../PaginationMixin';
import bookshopProjectsQuery from '../../queries/bookshopProjects';
import { UtilMixin } from '../../UtilMixin';
import Pager from '../shared/pager.vue';
import { ViewerContext } from '../../types/viewer_context';

@Component({ components: { Pager } })
export default class Projects extends Mixins(PaginationMixin, UtilMixin) {
  @Getter public viewerContext!: ViewerContext;

  public readonly query = bookshopProjectsQuery;

  public get queryVariables() {
    return {
      institutionId: this.viewerContext.institutionId,
      first: this.first,
      last: this.last,
      after: this.after,
      before: this.before,
    };
  }

  public projectLink(project: any): any {
    if (
      project == null ||
      !(project.state === 'IN_PROGRESS' || project.state === 'CREATED')
    ) {
      throw new Error('Can create a link for project');
    }

    if (project.state === 'IN_PROGRESS') {
      return {
        name: 'suggestionsList',
        params: { suggestionsListId: project.suggestionsListId },
      };
    } else {
      return { name: 'project', params: { projectId: project.id } };
    }
  }

  public projectLinkText(project: any): any {
    if (
      project == null ||
      !(project.state === 'IN_PROGRESS' || project.state === 'CREATED')
    ) {
      throw new Error('Can create a link for project');
    }

    if (project.state === 'IN_PROGRESS') {
      return this.$t('components.bookshop.projects.edit_suggestions');
    } else {
      return this.$t('components.bookshop.projects.see_details');
    }
  }
}
